/* eslint-disable import/first */
// Tracking must be imported first
import { Tracking } from "app/core/tracking"
import { AppProps, ErrorFallbackProps, ErrorBoundary } from "@blitzjs/next"
import { useSession } from "@blitzjs/auth"
import { useQueryErrorResetBoundary } from "@blitzjs/rpc"
import { withBlitz } from "blitz-client"
import LoginForm from "app/auth/components/LoginForm"
import "@reach/dialog/styles.css"
import "app/core/styles/index.css"
// TODO - convert test result reports to tailwind
import "app/test-results/styles.scss"
import Sentry from "integrations/sentry"
import ErrorComponent from "app/core/components/ErrorComponent"
import { Suspense, createElement, useEffect } from "react"
import SuperJson from "superjson"
import { I18nextProvider } from "react-i18next"
import i18n from "lib/i18n"
import { BannerNotification } from "app/core/components/BannerNotification"

SuperJson.allowErrorProps("type")

function App({ Component, pageProps, err }: AppProps & { err: any }) {
  const session = useSession({ suspense: false })
  const getLayout = (Component as any).getLayout || ((page) => page)

  useEffect(() => {
    if (session.userId) {
      Tracking.setUserId(session.userId)
    }
    if (session.orgId) {
      Tracking.setOrgId(session.orgId)
    }
  }, [session])

  return createElement(
    I18nextProvider,
    { i18n },
    <ErrorBoundary
      onError={(error, componentStack) => {
        Sentry.captureException(error, { contexts: { react: { componentStack } } })
      }}
      FallbackComponent={RootErrorFallback}
      onReset={useQueryErrorResetBoundary().reset}
    >
      <Suspense fallback={null}>
        <BannerNotification />
      </Suspense>
      <Suspense fallback={null}>
        {getLayout(createElement(Component, { ...pageProps, err } as any))}
      </Suspense>
    </ErrorBoundary>
  )
}

function RootErrorFallback({ error, resetErrorBoundary }: ErrorFallbackProps) {
  if (error.name === "AuthenticationError") {
    return <LoginForm onSuccess={resetErrorBoundary} />
  } else if (error.name === "AuthorizationError") {
    return (
      <ErrorComponent
        statusCode={(error as any).statusCode}
        title="Sorry, you are not authorized to access this"
      />
    )
  } else {
    return (
      <ErrorComponent
        statusCode={(error as any).statusCode || 400}
        title={error.message || error.name || "Unknown error"}
      />
    )
  }
}

export default withBlitz(App)
